<template lang="pug">
#modal-atalho-territorio
    el-dialog(
        width='600px',
        title='Cadastro de território',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        span.espacamento
            | Pessoa cadastrada com sucesso. Deseja cadastrar um novo território vinculado a esta pessoa?
        .botoes
            BaseButton(@click='fechar') Voltar
            BaseButton(type='primary', @click='irParaTerritorio') Cadastrar
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ModalAtalhoTerritorio',
    components: {
        BaseButton
    },
    props: {
        mostrar: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        irParaTerritorio() {
            this.$router.push({
                name: 'CadastrarEditarTerritorio',
                params: { cadastrar: 'pessoa' }
            });
        },

        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>
<style lang="scss">
.botoes {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
}

.espacamento {
    word-break: break-word;
}
</style>
